import React from 'react';
import { getFlowNode } from './Flow.ts';
import { useAppState } from './BikesAppState.tsx';
import AdapterSelector from './Components/AdapterSelector/AdapterSelector.tsx';
import AxleSelector from './Components/AxleSelector/AxleSelector.tsx';
import ChoiceStep from './Components/Flow/ChoiceStep.tsx';
import ResultStep from './Components/Flow/ResultStep.tsx';

const StepRouter = () => {
  const { currentNodeId } = useAppState();
  const node = getFlowNode(currentNodeId);

  if (currentNodeId === 'axle') {
    return <AxleSelector />;
  }

  if (currentNodeId === 'buyAdapter') {
    return <AdapterSelector node={node} />;
  }

  if (node.kind === 'choice') {
    return <ChoiceStep node={node} />;
  }

  return <ResultStep node={node} />;
};

export default StepRouter;
